import { Clock, Loader2, CheckCircle, AlertTriangle } from 'lucide-react';

const STATUS_STYLES = {
  Pending: { bg: 'bg-slate-100', text: 'text-slate-700', icon: Clock },
  Generating: { bg: 'bg-amber-100', text: 'text-amber-800', icon: Loader2 },
  Ready: { bg: 'bg-emerald-100', text: 'text-emerald-800', icon: CheckCircle },
  Failed: { bg: 'bg-red-100', text: 'text-red-800', icon: AlertTriangle },
};

export const isInFlight = (d) => d && (d.status === 'Pending' || d.status === 'Generating');

export const StatusPill = ({ status }) => {
  const cfg = STATUS_STYLES[status] || STATUS_STYLES.Pending;
  const Icon = cfg.icon;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${cfg.bg} ${cfg.text}`}
      data-testid={`deck-status-${status.toLowerCase()}`}
    >
      <Icon size={12} className={status === 'Generating' ? 'animate-spin' : ''} />
      {status}
    </span>
  );
};

export const FormatBadge = ({ format }) => (
  <span
    className={`text-[10px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded ${
      format === 'pptx' ? 'bg-orange-50 text-orange-700' : 'bg-sky-50 text-sky-700'
    }`}
    data-testid={`deck-format-${format}`}
  >
    {format === 'pptx' ? 'PowerPoint' : 'Word'}
  </span>
);
